import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <rect x="1" y="1" width="38" height="38" rx="9" fill="#E11D48" />
    <circle cx="20" cy="20" r="10.5" fill="none" stroke="#090D12" strokeWidth="3" />
    <circle cx="20" cy="20" r="4.5" fill="#090D12" />
    <path d="M20 3.5v5M20 31.5v5M3.5 20h5M31.5 20h5" stroke="#090D12" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const Logo = () => (
  <Link to="/" data-testid="header-logo-link" className="group flex items-center gap-3">
    <span className="transition-transform duration-500 group-hover:rotate-90">
      <LogoMark />
    </span>
    <span className="font-display text-2xl font-extrabold uppercase leading-none tracking-tight">
      CBLS <span className="text-[#E11D48]">Airbags</span>
    </span>
  </Link>
);
